import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["clients", "projects", "team", "reports"]
  static values = {
    id: String
  }

  connect() {
    // Initialize checkboxes based on current permissions
    this.updateCheckboxesFromRole()

    // Add form submission handling
    this.element.addEventListener("turbo:submit-end", this.handleSubmit.bind(this))
  }

  disconnect() {
    // Clean up event listener
    this.element.removeEventListener("turbo:submit-end", this.handleSubmit.bind(this))
  }

  handleSubmit(event) {
    // Scroll to top when the form submission is complete
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  sendWelcomeEmail(event) {
    event.preventDefault()
    const form = event.currentTarget
    
    fetch(form.action, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
        "Accept": "text/vnd.turbo-stream.html"
      }
    })
    .then(response => response.text())
    .then(html => {
      Turbo.renderStreamMessage(html)
      
      // Close the dropdown after successful action
      const dropdown = form.closest('.dropdown')
      if (dropdown) {
        const dropdownButton = dropdown.querySelector('button[tabindex="0"]')
        if (dropdownButton) dropdownButton.blur()
      }
    })
    .catch(error => {
      console.error("Error sending welcome email:", error)
    })
  }

  sendPasswordReset(event) {
    event.preventDefault()
    const form = event.currentTarget
    
    fetch(form.action, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
        "Accept": "text/vnd.turbo-stream.html"
      }
    })
    .then(response => response.text())
    .then(html => {
      Turbo.renderStreamMessage(html)
      
      // Close the dropdown after successful action
      const dropdown = form.closest('.dropdown')
      if (dropdown) {
        const dropdownButton = dropdown.querySelector('button[tabindex="0"]')
        if (dropdownButton) dropdownButton.blur()
      }
    })
    .catch(error => {
      console.error("Error sending password reset:", error)
    })
  }

  loginAs(event) {
    event.preventDefault()
    const userId = event.currentTarget.dataset.teamMemberFormUserIdParam
    const userName = event.currentTarget.dataset.teamMemberFormUserNameParam
    
    if (confirm(`Are you sure you want to login as ${userName}?`)) {
      // Create a form element for direct submission
      const form = document.createElement('form')
      form.method = 'POST'
      form.action = `/team/${userId}/login_as`
      
      // Add CSRF token
      const csrfToken = document.querySelector('meta[name="csrf-token"]').content
      const csrfInput = document.createElement('input')
      csrfInput.type = 'hidden'
      csrfInput.name = 'authenticity_token'
      csrfInput.value = csrfToken
      form.appendChild(csrfInput)
      
      // Append form to body and submit
      document.body.appendChild(form)
      form.submit()
    }
  }

  toggleSection(event) {
    const section = event.target.dataset.section
    const checkboxes = this[`${section}Target`].querySelectorAll('input[type="checkbox"]')
    
    checkboxes.forEach(checkbox => {
      checkbox.disabled = !event.target.checked
      if (!event.target.checked) {
        checkbox.checked = false
      }
    })
  }

  updateCheckboxesFromRole() {
    const roleSelect = this.element.querySelector('select[name="user[role]"]')
    
    // Skip if roleSelect doesn't exist
    if (!roleSelect || !roleSelect.selectedOptions || !roleSelect.selectedOptions[0]) {
      console.log("Role select element not found or has no selected options")
      return
    }
    
    const currentPermissions = JSON.parse(roleSelect.selectedOptions[0].dataset.permissions || '{}')

    // Update each section's checkboxes based on the role's permissions
    Object.entries(currentPermissions).forEach(([section, data]) => {
      if (this.hasTarget(section)) {
        const sectionToggle = this.element.querySelector(`[data-section="${section}"]`)
        const hasPermissions = data.permissions && Object.values(data.permissions).some(v => v)
        
        if (sectionToggle) {
          sectionToggle.checked = hasPermissions
          this.toggleSection({ target: sectionToggle })
        }

        // Set individual permission checkboxes
        if (data.permissions) {
          Object.entries(data.permissions).forEach(([perm, value]) => {
            const checkbox = this[`${section}Target`].querySelector(`input[name="user[role_permissions][${section}][permissions][${perm}]"]`)
            if (checkbox) {
              checkbox.checked = value
            }
          })
        }
      }
    })
  }
} 